import { DateTime } from "luxon";
import type { SingleDateRangeValue } from "../DateRangeInput";

interface GetStartMinimumParams {
  tempEnd: SingleDateRangeValue;
  startInputPropMin?: DateTime;
  globalMin?: DateTime;
  maxRangeInDays?: number;
}

function getStartMinimum({
  tempEnd,
  startInputPropMin,
  globalMin,
  maxRangeInDays
}: GetStartMinimumParams): DateTime | undefined {
  const rangeImpliedMin =
    tempEnd && maxRangeInDays
      ? tempEnd.minus({ days: maxRangeInDays })
      : undefined;
  const startMinCandidates = [
    startInputPropMin,
    globalMin,
    rangeImpliedMin
  ].filter((d): d is DateTime => d !== undefined && d !== null);
  return DateTime.min(...startMinCandidates);
}

export { getStartMinimum };
